import type { SelfDescribingJson } from '@snowplow/browser-tracker';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

export type FormElement = {
  name: string;
  value: string | null;
  nodeName: string;
};

export type SubmitFormData = {
  id: string;
  elements: FormElement[];
};

export function trackSubmitForm(
  eventData: SubmitFormData,
  contexts?: SelfDescribingJson[] | null,
): void {
  trackSelfDescribingEvent({
    event: {
      schema:
        'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
      data: {
        formId: eventData.id,
        elements: eventData.elements.map((element) => ({
          name: element.name,
          value: element.value,
          nodeName: element.nodeName,
        })),
      },
    },
    context: contexts,
  });
}
